"use client";

import { useEffect } from "react";
import { installErrorReporting } from "@/lib/error-reporting";

export default function ErrorReportingInstaller() {
  useEffect(() => {
    installErrorReporting();
  }, []);
  return null;
}
